import type { IconProp } from '@atlaskit/button/variants/types';

import { SlackIcon, TeamsIcon } from '../icons/ThirdPartyMessageProductIcons';

import { type ExternalMessageDmIntegrationInfo } from './thirdPartyMessaging';

/**
 * Product icons for "open in Slack / Microsoft Teams" actions. SVG components are cast to `IconProp` for `LinkIconButton`.
 */
export const EXTERNAL_MESSAGE_INTEGRATION_ICONS: Record<
	ExternalMessageDmIntegrationInfo['integration'],
	IconProp
> = {
	slack: SlackIcon as IconProp,
	teams: TeamsIcon as IconProp,
};

export function getIconForExternalMessageIntegration(
	integration: ExternalMessageDmIntegrationInfo['integration'],
): IconProp {
	return EXTERNAL_MESSAGE_INTEGRATION_ICONS[integration];
}
